// Event-specific configuration — the reusable-playbook seam.
// Edit this (and rebuild) for each new listening-session board.

import type { BoardConfig } from "@ts/core/types.ts";

// The Cloudflare Worker API that backs all NEW boxes (/b/<slug>). The root
// path (the frozen Old Friend board) still reads from Supabase below, and
// will later become a static snapshot.
export const API_BASE = "https://memorybox-api.itsallforiris.workers.dev";

export const BOARD_CONFIG: BoardConfig = {
  title: "memorybox",
  tagline: "notes from the room",
  subtitle: "Old Friend · an evening in Chennai · 16 July 2026",
  introLine:
    "Thank you for being there and for making it special with your presence. If you have something to share from the evening - maybe you didn't get a chance to speak, maybe you wanted to say something more, or just reflect on what the evening felt like - you can leave a note, a photo or a voice note. Think of this like a slam book for the listening session that we shared. On {freezeDate} the studio version will be out on all streaming platforms, and this board will be frozen and shared with everyone who was in the room. with 🤍 shakthi",
  slamLine: "",
  composeButton: "leave a note",
  freezeNotice: "this board is now frozen - thank you for being there 🤍",
  // freeze day = the day the studio version of Old Friend drops
  freezeAt: "2026-07-31T23:59:59+05:30",
  maxChars: 280,
  maxNotesPerPerson: 3,
  maxStickersPerPerson: 6,
  supabaseUrl: "https://tetrbmzyrlkvitmutilv.supabase.co",
  supabaseAnonKey: "sb_publishable_ElYhspJicy2ts4XGhUL4Hw_e_7iPxHF",
};
